import { create } from 'zustand'

/** El evento que Chrome/Android disparan cuando la PWA cumple los
 *  requisitos para instalarse. Firefox y Safari no lo tienen tipado en
 *  el DOM estándar, así que se declara acá. */
interface EventoInstalacion extends Event {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>
}

interface EstadoInstalacion {
  /** Solo existe en Chrome/Edge/Android cuando el navegador decide que
   *  la app es instalable. En iPhone (Safari) nunca llega —ahí la
   *  única forma es "Compartir → Añadir a pantalla de inicio". */
  evento: EventoInstalacion | null
  instalada: boolean
  guardarEvento: (e: EventoInstalacion) => void
  limpiar: () => void
}

export const useInstalacion = create<EstadoInstalacion>((set) => ({
  evento: null,
  // display-mode "standalone" es como se ve la app una vez instalada y
  // abierta desde el ícono, no desde el navegador.
  instalada:
    typeof window !== 'undefined' && window.matchMedia('(display-mode: standalone)').matches,
  guardarEvento: (e) => set({ evento: e }),
  limpiar: () => set({ evento: null, instalada: true }),
}))

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    useInstalacion.getState().guardarEvento(e as EventoInstalacion)
  })
  window.addEventListener('appinstalled', () => {
    useInstalacion.getState().limpiar()
  })
}
